import React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { showSnack } from "react-redux-snackbar";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { endpoints } from "../../../Constants/endpoints";
import { FeedbackCategory, FeedbackState } from "../../../Constants/feedbackEnums";
import FeedbackStateChangeButton from "./FeedbackStateChangeButton";
import { IAppState, appPaths, ApiRequest } from "../../../../Common";
import { Feedback } from "../../../Models/Feedback";
import styles from "../../../Styles/FeedbackButtons.module.scss";
import { StatusCode } from "../../../../App/Enums/StatusCode";
import { Transition } from "../../../../Workflows/Models/Transition";

type ArgumentProps = {
  feedback: Feedback;
  hideWorkflowButtons?: boolean;
  hideAdminButtons?: boolean;
  onStateChange: (feedbackCode: string) => void;
};

type DispatchProps = {
  showSnack: (uniqueId: any, args: any) => void;
};

function mapDispatchToProps(dispatch: ThunkDispatch<IAppState, {}, any>): DispatchProps {
  return {
    showSnack: (uniqueId: any, args: any) => dispatch(showSnack(uniqueId, args))
  };
}

class FeedbackStateChangeButtons extends React.Component<ArgumentProps & DispatchProps> {
  stateLock: boolean;

  constructor(props: ArgumentProps & DispatchProps) {
    super(props);

    this.onChangeFeedbackStateClick = this.onChangeFeedbackStateClick.bind(this);
    this.onUndo = this.onUndo.bind(this);

    this.stateLock = false;
  }

  onChangeFeedbackStateClick(transition: Transition) {
    if (!this.claimStateLock()) {
      return;
    }

    ApiRequest.fromPath(endpoints.feedback.transition(this.props.feedback.code))
      .withJson({ transitionId: transition.id })
      .withAuthHeader()
      .post()
      .then(response => {
        if (response.status === StatusCode.Status200OK) {
          this.onSuccessfulFeedbackTransition(transition);
        } else {
          response.json().then(json => {
            this.showErrorSnackbar(response.status, json.title);
          });
        }
        this.releaseStateLock();
      });
  }

  // onChangeFeedbackStateClick(targetState: FeedbackState) {
  //   if (!this.claimStateLock()) {
  //     return;
  //   }

  //   ApiRequest.fromPath(endpoints.feedback.state(this.props.feedback.code))
  //     .withJson({ state: targetState })
  //     .withAuthHeader()
  //     .post()
  //     .then(response => {
  //       if (response.status === StatusCode.Status200OK) {
  //         this.onSuccessfulFeedbackStateChange(targetState);
  //       } else {
  //         response.json().then(json => {
  //           this.showErrorSnackbar(response.status, json.title);
  //         });
  //       }
  //       this.releaseStateLock();
  //     });
  // }

  onSuccessfulFeedbackTransition(transition: Transition) {
    this.props.showSnack("CHANGE_FEEDBACK_STATE", {
      label: `Feedback has been updated to state: ${transition.targetState.name}`,
      timeout: 5000
      // button: {
      //   label: "Undo",
      //   action: (snack: any) => {
      //     this.onUndo(snack)
      //   }
      // }
    });

    if (this.props.onStateChange) {
      this.props.onStateChange(this.props.feedback.code);
    }
  }

  onUndo(snack: any) {
    // console.log("Undo clicked");
    // console.log(snack);
  }

  getWorkflowButtons(): JSX.Element {
    if (!this.props.feedback.permissions) {
      throw Error("Cannot get buttons without feedback permissions loaded");
    }

    return (
      <>
        {this.props.feedback.possibleTransitions.map(el => {
          let icon: JSX.Element = <></>;
          if (el.targetState.imageUrl) {
            // TODO CHange
            icon = <img src={el.targetState.imageUrl} className={styles.feedbackButtonImage} />;
          } else {
            icon = (
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_ArrowRight"
                className={iconStyles.smallIcon}
              />
            );
          }

          return (
            <>
              <FeedbackStateChangeButton
                icon={icon}
                title={el.actionText}
                onClick={() => this.onChangeFeedbackStateClick(el)}
              />
            </>
          );
        })}
      </>
    );
  }

  showErrorSnackbar(errorCode: number, errorDescription: string) {
    this.props.showSnack("CHANGE_FEEDBACK_STATE", {
      label: `Failed to change Feedback State: ${errorDescription} (Error Code ${errorCode})`,
      timeout: 5000
    });
  }

  claimStateLock() {
    if (!this.stateLock) {
      this.stateLock = true;
      return true;
    }
    return false;
  }

  releaseStateLock() {
    this.stateLock = false;
  }

  render() {
    return <>{!this.props.hideWorkflowButtons && <>{this.getWorkflowButtons()}</>}</>;
  }
}

export default connect(null, mapDispatchToProps)(FeedbackStateChangeButtons);
